/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseResponse,
  HTTPValidationError,
  RegulatoryAnalysisRequest,
  RegulatoryAnalysisResponse,
  RegulatoryChangeRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Regulatory<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Analyzes regulatory changes and their impact on business operations, providing actionable compliance strategies, implementation timelines, and resource requirements.
   *
   * @tags regulatory
   * @name RegulatoryAnalysisEndpointRegulatoryApiRegulatoryAnalysisPost
   * @summary AI-Powered Compliance Monitoring System
   * @request POST:/regulatory/api/regulatory-analysis
   */
  regulatoryAnalysisEndpointRegulatoryApiRegulatoryAnalysisPost = (
    data: RegulatoryChangeRequest,
    params: RequestParams = {},
  ) =>
    this.request<BaseResponse, HTTPValidationError>({
      path: `/regulatory/api/regulatory-analysis`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Realiza un análisis exhaustivo del cumplimiento regulatorio según el marco normativo colombiano, incluyendo evaluación de riesgos y recomendaciones.
   *
   * @tags regulatory
   * @name AnalyzeRegulatoryEndpointRegulatoryAnalyzePost
   * @summary Análisis de Cumplimiento Regulatorio
   * @request POST:/regulatory/analyze
   */
  analyzeRegulatoryEndpointRegulatoryAnalyzePost = (data: RegulatoryAnalysisRequest, params: RequestParams = {}) =>
    this.request<RegulatoryAnalysisResponse, HTTPValidationError>({
      path: `/regulatory/analyze`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Obtiene los marcos regulatorios disponibles por sector
   *
   * @tags regulatory
   * @name GetRegulatoryFrameworksRegulatoryFrameworksGet
   * @summary Marcos Regulatorios Disponibles
   * @request GET:/regulatory/frameworks
   */
  getRegulatoryFrameworksRegulatoryFrameworksGet = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/regulatory/frameworks`,
      method: "GET",
      format: "json",
      ...params,
    });
}
